<template>
  <modal
    :title="$t('titles.addRecommendation')"
    @hidden="resetForm"
    class="product-recommendation-form"
    playground
    ref="modal"
  >
    <form @submit.prevent="submit">
      <div class="uk-modal-body">
        <product-combobox
          :disabled="!isEditable"
          :errors="form.errors.product"
          :filter="{ bundle: false, omittedIds: this.unselectableProductIds }"
          v-model="form.model.product"
        />
      </div>
      <div class="uk-modal-footer uk-text-right">
        <submit-button
          :disabled="!isSubmittable"
          type="primary"
        >{{$t('actions.add')}}</submit-button>
        <common-button @click="hide">{{$t('actions.cancel')}}</common-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/LegacyForm';
import Modal from '@/components/Modal';
import ProductCombobox from '@/components/ProductCombobox';
import SubmitButton from '@/components/SubmitButton';

export default {
  name: 'product-recommendation-form',
  components: {
    CommonButton,
    Modal,
    ProductCombobox,
    SubmitButton,
  },
  mixins: [
    Authentication,
    Form({
      product: {
        required: true,
        serializeTo: 'recommendedProductId',
        serialize: product => product.id,
      },
    }),
  ],
  props: {
    unselectableProductIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resetForm() {
      this.form.model.product = null;
      this.form.errors.product = [];
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          product: 'Produkt',
        },
        titles: {
          addRecommendation: 'Empfehlung hinzufügen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductRecommendationForm.vue?1f57d407